import { render, staticRenderFns } from "./MyPaymentsTableMobile.vue?vue&type=template&id=0c832496&scoped=true"
import script from "./MyPaymentsTableMobile.vue?vue&type=script&lang=js"
export * from "./MyPaymentsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c832496",
  null
  
)

export default component.exports